// Tillåt olika varianter av latinska bokstäver, siffror och utvalda symboltecken
// Kan användas till att validera namn, adresser etc
export const nameValidationRegex = /^[\\[a-zA-Z0-9\u0020-\u002f\u003a-\u0040\u005f\u00c0-\u00d6\u00d8-\u017e]*$/;